import React from 'react'

export default class Test extends React.Component{
    render(){
        return (
            <h1>Work0</h1>
        )
    }
}